<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import Modal from '$lib/components/Modal/Modal.svelte';
	import copyToClipboard from '$lib/utils/copyToClipboard';
	import { onMount } from 'svelte';

	let debugModal = false;
	let debugInfo: { [key: string]: unknown } = {
		app: 'hubs-ui (Svelte)',
		version: 'TODO', // Generate version during `docker build` somehow
		apiVersion: '...',
	};
	let debugModalCheat: string[] = [];

	const { user, hub, api } = getHubStores();

	const getDebugInfo = async () => {
		debugInfo.cookies = navigator?.cookieEnabled;
		debugInfo.userAgent = navigator.userAgent;
		debugInfo.session = $user;
		debugInfo.hub = $hub;

		try {
			const resp = await api.getVersion();
			debugInfo.apiVersion = resp.version || 'unknown';
		} catch (e) {
			console.error(e);
		}
	};

	onMount(() => {
		// TODO: .onkeypress is deprecated (but works in Chrome) -- how do we replace it?
		document.onkeypress = function (event) {
			let char = event.keyCode || event.which;

			if (debugModalCheat.length == 3) {
				[, ...debugModalCheat] = debugModalCheat; // trim to 2 chars
			}

			debugModalCheat = [...debugModalCheat, String.fromCharCode(char)];

			// check cheat
			if (debugModalCheat.toString() === '~,!,@') {
				debugModal = true;
				void getDebugInfo();
			}
		};
	});
</script>

<Modal bind:isOpen={debugModal}>
	<div class="debugModal" slot="content">
		<h1>Debug information</h1>
		<h2>The following are the details of your current session.</h2>

		<pre>
			{@html JSON.stringify(debugInfo, null, 2)}
		</pre>

		<button type="button" on:click={() => copyToClipboard(JSON.stringify(debugInfo, null, 2))}
			>Copy debug info</button>
	</div>
</Modal>

<style>
	.debugModal {
		block-size: 600px;
		inline-size: 800px;
		padding: 10px;
	}

	pre {
		block-size: 50%;
		inline-size: 750px;
		background-color: #eee;
	}
</style>
